<template lang="html">
	<form class="form-ui column default-form-ui" novalidate>
		<div class="ctn-input ctn-label" v-inputUI :class="{ error: errors.has('name') }">
			<label for="name">Nom de l'opération</label>
			<input v-validate="'required'" type="text" name="name" v-model="operation.name">
		</div>
		<div class="ctn-big-block row">
			<div class="column">
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label no-border" v-selectUI :class="{error: errors.has('client')}">
							<label for="client">Client</label>
							<custom-select-user :items="clients" v-model="operation.client" :disabled="missionExist"/>
						</div>
						<div v-if="errors.has('client')" class="error-message">{{ errors.first('client') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('contrat')}">
							<label for="contrat">ID Client</label>
							<input type="text" name="ref_client" :value="operation.client ? '#' + operation.client.id : ''" readonly disabled>
						</div>
						<div v-if="errors.has('contrat')" class="error-message">{{ errors.first('contrat') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="inner-row">
						<div class="ctn-input ctn-label ctn-currency" v-inputUI :class="{error: errors.has('montant')}">
							<label for="montant">Montant</label>
							<input v-validate="'required'" type="text" name="montant" v-model="operation.amount.value">
							<custom-select :items="currencyList" v-model="operation.amount.currency" />
						</div>
						<div v-if="errors.has('montant')" class="error-message">{{ errors.first('montant') }}</div>
					</div>
				</div>
			</div>
			<div class="column">
				<div class="ctn-input ctn-label ctn-textarea" v-inputUI :class="{ error: errors.has('name') }">
					<label for="description">Description</label>
					<textarea v-validate="'required'" name="description" v-model="operation.description"></textarea>
				</div>
			</div>
		</div>
		<div class="ctn-cta row start">
				<router-link :to="{ name: 'TransactionsTable' }" class="ctn-icon">
					<div class="btn btn-gold">Annuler</div>
				</router-link>
			<div class="btn btn-red" @click="saveOperation">
				Enregistrer
			</div>
		</div>
	</form>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import CustomSelectUser from '@/common/components/Form/CustomSelectUser'
import { mapGetters } from 'vuex'

export default {
	name: 'EditMain',
	components: {
		CustomSelect,
		CustomSelectUser
	},
	data () {
		return {
			currencyList: Currency,
			missionExist: false,
			operation: {
				name: null,
				description: null,
				client: null,
				advisor: null,
				amount: {
					value: null,
					currency: 'EUR'
				},
				type: null,
				docs: {
					missionLetter: null,
					missionCR: null,
					contractSubscription: null
				},
				contracts: []
			},
			operationTypeList: ['Financier', 'Tangible', 'International']
		}
	},
	mounted () {
		this.operation.advisor = this.advisor
		this.$store.dispatch('getContracts')
		if (this.$route.name === 'MyTransactionsEdit') {
			this.missionExist = true
			const o = this.$store.getters.operation(this.$route.params.id)
			this.operation = {
				id: this.$route.params.id,
				client: o.client.user,
				name: o.title,
				description: o.description,
				advisor: o.advisor.id,
				amount: {
					value: o.total_value,
					currency: o.currency
				},
				docs: {
					missionLetter: null,
					missionCR: null,
					contractSubscription: null
				},
				contracts: []
			}
		}
	},
	methods: {
		createOperation () {
			this.$store.dispatch('createOperation', this.operation)
			.then((result) => {
				this.missionExist = true
				this.$router.push({ name: 'MyTransactionsEdit', params: { id: result.id } })
			})
			.catch((e) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				})
			})
		},
		patchOperation () {
			this.$store.dispatch('patchOperation', this.operation)
			.then((result) => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'L\'opération a bien été modifiée',
					text: ''
				})
			}).catch((e) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				})
			})
		},
		saveOperation () {
			if (this.missionExist) {
				this.patchOperation()
			} else {
				this.createOperation()
			}
		}
	},
	computed: {
		...mapGetters({
			advisor: 'user',
			clients: 'getClients'
		})
	}
}
</script>

<style lang="scss">
.ctn-duo-input {
	.inner-row {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// Main.vue?7fbc4752